import {
  EXTENSION_URL,
  RELATED_PERSON_ASSOCIATION,
} from '@constants/extension-codes';

import { RelatedPersonRecord, type FormValues } from '@models/related-person';

import { formatPatientId } from '@utils/format';

import type { RelatedPersonModelInput } from 'generated/types';

export function getRelatedPersonTemplate(
  patient_id: string,
  values: FormValues
): RelatedPersonModelInput {
  const {
    address,
    address2,
    association,
    city,
    country,
    email,
    first_name,
    last_name,
    phone,
    postalCode,
    region,
    roles,
  } = values;

  return {
    resourceType: 'RelatedPerson',
    patient: {
      reference: formatPatientId(patient_id),
    },
    active: true,
    ...((city || country || address || postalCode || region) && {
      address: [
        {
          ...(city && {
            city,
          }),
          ...(country && {
            country,
          }),
          ...(address && {
            line: [address, ...(address2 ? [address2] : [])],
          }),
          ...(postalCode && {
            postalCode,
          }),
          ...(region && {
            state: region,
          }),
        },
      ],
    }),
    name: [
      {
        family: last_name,
        ...(first_name && {
          given: [first_name],
        }),
      },
    ],
    relationship: roles.map(({ role_code, role_name }) => {
      return {
        coding: [
          {
            code: role_code,
            display: role_name,
            system: RelatedPersonRecord.VITALL_SYSTEM,
          },
        ],
        text: role_name,
      };
    }),
    ...((phone || email) && {
      telecom: [
        ...(phone
          ? [
              {
                system: 'phone',
                value: phone,
              },
            ]
          : []),
        ...(email
          ? [
              {
                system: 'email',
                value: email,
              },
            ]
          : []),
      ],
    }),
    ...(association && {
      extension: [
        {
          url: `${EXTENSION_URL}${RELATED_PERSON_ASSOCIATION}`,
          valueString: association,
        },
      ],
    }),
  };
}
